import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DomHandler } from '@dm/ang';
import { CoreModule } from '@dm/core';

import { ConfigPolicySComponent } from './config-policy-s.component';

@NgModule({
    declarations: [ConfigPolicySComponent],
    exports: [ConfigPolicySComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [DomHandler],
})
export class ConfigPolicySModule { }
